import sendGaGtmEvent, {
  GA_GTM_CATEGORY_CLICK_ACTIONS,
  GA_GTM_EVENT_NAMES,
  GA_GTM_NAVIGATION,
} from "./sendGaGtmEvent";

export const trackCategoryBannerClick = (
  parentMenuTitle: string,
  dataGtm: string
) => {
  sendGaGtmEvent({
    gtmEventName: GA_GTM_EVENT_NAMES.CATEGORY_BANNERS,
    eventCategory: "",
    eventAction: parentMenuTitle,
    eventLabel: dataGtm,
  });
};

export const trackCategoryClick = (
  eventAction: (typeof GA_GTM_CATEGORY_CLICK_ACTIONS)[keyof typeof GA_GTM_CATEGORY_CLICK_ACTIONS],
  eventLabel: string
) => {
  sendGaGtmEvent({
    gtmEventName: GA_GTM_EVENT_NAMES.CATEGORY_CLICK,
    eventCategory: "",
    eventAction,
    eventLabel,
  });
};

export const trackCategoryExpand = (eventLabel: string) => {
  sendGaGtmEvent({
    gtmEventName: GA_GTM_EVENT_NAMES.CATEGORY_EXPAND,
    eventCategory: GA_GTM_NAVIGATION.CATEGORY,
    eventAction: GA_GTM_NAVIGATION.EXPAND_ACTION,
    eventLabel,
  });
};

export const trackCategoryCollapse = (eventLabel: string) => {
  sendGaGtmEvent({
    gtmEventName: GA_GTM_EVENT_NAMES.CATEGORY_COLLAPSE,
    eventCategory: GA_GTM_NAVIGATION.CATEGORY,
    eventAction: GA_GTM_NAVIGATION.COLLAPSE_ACTION,
    eventLabel,
  });
};
